import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const SpecialHandlingDeliveriesDetailsInner = React.lazy(() =>
  import("../components/SpecialHandlingDeliveriesDetailsInner")
);
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const SpecialHandlingDeliveries = () => {
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* Breadcrumb */}
          <Breadcrumb title={"SPECIAL HANDLING DELIVERIES"} />

          {/* Service Details Inner */}
          <SpecialHandlingDeliveriesDetailsInner />

          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>{" "}
      </Fragment>
    </>
  );
};

export default SpecialHandlingDeliveries;
